import React from 'react';

export interface ToggleSwitchProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  variant?: 'default' | 'danger';
}

/**
 * ToggleSwitch Component
 * 
 * A reusable toggle switch component with ON/OFF states.
 * 
 * @param label - Label text for the toggle
 * @param isActive - Whether the toggle is in ON state
 * @param onClick - Callback function when toggle is clicked
 * @param variant - Visual variant ('default' or 'danger')
 */
export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  label,
  isActive,
  onClick,
  variant = 'default',
}) => {
  const isDanger = variant === 'danger';
  const labelColor = isDanger ? 'text-red-600' : 'text-[var(--text-primary)]';
  const activeColor = isDanger ? 'bg-red-500' : 'bg-[var(--accent-color)]';

  return (
    <div className="flex items-center justify-between p-3 bg-white border border-[var(--border-color)] rounded gap-3">
      <span className={`text-sm font-medium ${labelColor}`}>{label}</span>
      <button
        onClick={onClick}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
          isActive ? activeColor : 'bg-gray-200'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            isActive ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  );
};
